"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrganizationControllerSetBlockchainAddress = exports.organizationControllerSetBlockchainAddress = exports.useOrganizationControllerSetSelfOwnershipFlag = exports.organizationControllerSetSelfOwnershipFlag = exports.useOrganizationControllerChangeMemberRole = exports.organizationControllerChangeMemberRole = exports.useOrganizationControllerRemoveMember = exports.organizationControllerRemoveMember = exports.useOrganizationControllerGetUsers = exports.getOrganizationControllerGetUsersQueryKey = exports.organizationControllerGetUsers = exports.useOrganizationControllerGetInvitationsForOrganization = exports.getOrganizationControllerGetInvitationsForOrganizationQueryKey = exports.organizationControllerGetInvitationsForOrganization = exports.useOrganizationControllerGetPublic = exports.getOrganizationControllerGetPublicQueryKey = exports.organizationControllerGetPublic = exports.useOrganizationControllerUpdate = exports.organizationControllerUpdate = exports.useOrganizationControllerDelete = exports.organizationControllerDelete = exports.useOrganizationControllerGet = exports.getOrganizationControllerGetQueryKey = exports.organizationControllerGet = exports.useOrganizationControllerRegister = exports.organizationControllerRegister = exports.useOrganizationControllerGetAll = exports.getOrganizationControllerGetAllQueryKey = exports.organizationControllerGetAll = void 0;
/**
 * Generated by orval v6.5.1 🍺
 * Do not edit manually.
 * Exchange I-REC API
 * Swagger documentation for the Exchange I-REC API
 * OpenAPI spec version: 0.1
 */
const react_query_1 = require("react-query");
const response_type_1 = __importDefault(require("../response-type"));
const response_type_2 = __importDefault(require("../response-type"));
const response_type_3 = __importDefault(require("../response-type"));
const response_type_4 = __importDefault(require("../response-type"));
const response_type_5 = __importDefault(require("../response-type"));
const response_type_6 = __importDefault(require("../response-type"));
const response_type_7 = __importDefault(require("../response-type"));
const response_type_8 = __importDefault(require("../response-type"));
const response_type_9 = __importDefault(require("../response-type"));
const response_type_10 = __importDefault(require("../response-type"));
const response_type_11 = __importDefault(require("../response-type"));
const response_type_12 = __importDefault(require("../response-type"));
const organizationControllerGetAll = () => {
    return (0, response_type_1.default)({ url: `/api/Organization`, method: 'get'
    });
};
exports.organizationControllerGetAll = organizationControllerGetAll;
const getOrganizationControllerGetAllQueryKey = () => [`/api/Organization`];
exports.getOrganizationControllerGetAllQueryKey = getOrganizationControllerGetAllQueryKey;
const useOrganizationControllerGetAll = (options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrganizationControllerGetAllQueryKey)();
    const queryFn = () => (0, exports.organizationControllerGetAll)();
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, queryOptions);
    return Object.assign({ queryKey }, query);
};
exports.useOrganizationControllerGetAll = useOrganizationControllerGetAll;
const organizationControllerRegister = (newOrganizationDTO) => {
    return (0, response_type_2.default)({ url: `/api/Organization`, method: 'post',
        data: newOrganizationDTO
    });
};
exports.organizationControllerRegister = organizationControllerRegister;
const useOrganizationControllerRegister = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.organizationControllerRegister)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerRegister = useOrganizationControllerRegister;
const organizationControllerGet = (id) => {
    return (0, response_type_3.default)({ url: `/api/Organization/${id}`, method: 'get'
    });
};
exports.organizationControllerGet = organizationControllerGet;
const getOrganizationControllerGetQueryKey = (id) => [`/api/Organization/${id}`];
exports.getOrganizationControllerGetQueryKey = getOrganizationControllerGetQueryKey;
const useOrganizationControllerGet = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrganizationControllerGetQueryKey)(id);
    const queryFn = () => (0, exports.organizationControllerGet)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useOrganizationControllerGet = useOrganizationControllerGet;
const organizationControllerDelete = (id) => {
    return (0, response_type_4.default)({ url: `/api/Organization/${id}`, method: 'delete'
    });
};
exports.organizationControllerDelete = organizationControllerDelete;
const useOrganizationControllerDelete = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id } = props || {};
        return (0, exports.organizationControllerDelete)(id);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerDelete = useOrganizationControllerDelete;
const organizationControllerUpdate = (id, organizationUpdateDTO) => {
    return (0, response_type_5.default)({ url: `/api/Organization/${id}`, method: 'put',
        data: organizationUpdateDTO
    });
};
exports.organizationControllerUpdate = organizationControllerUpdate;
const useOrganizationControllerUpdate = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, data } = props || {};
        return (0, exports.organizationControllerUpdate)(id, data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerUpdate = useOrganizationControllerUpdate;
const organizationControllerGetPublic = (id) => {
    return (0, response_type_6.default)({ url: `/api/Organization/${id}/public`, method: 'get'
    });
};
exports.organizationControllerGetPublic = organizationControllerGetPublic;
const getOrganizationControllerGetPublicQueryKey = (id) => [`/api/Organization/${id}/public`];
exports.getOrganizationControllerGetPublicQueryKey = getOrganizationControllerGetPublicQueryKey;
const useOrganizationControllerGetPublic = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrganizationControllerGetPublicQueryKey)(id);
    const queryFn = () => (0, exports.organizationControllerGetPublic)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useOrganizationControllerGetPublic = useOrganizationControllerGetPublic;
const organizationControllerGetInvitationsForOrganization = (id) => {
    return (0, response_type_7.default)({ url: `/api/Organization/${id}/invitations`, method: 'get'
    });
};
exports.organizationControllerGetInvitationsForOrganization = organizationControllerGetInvitationsForOrganization;
const getOrganizationControllerGetInvitationsForOrganizationQueryKey = (id) => [`/api/Organization/${id}/invitations`];
exports.getOrganizationControllerGetInvitationsForOrganizationQueryKey = getOrganizationControllerGetInvitationsForOrganizationQueryKey;
const useOrganizationControllerGetInvitationsForOrganization = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrganizationControllerGetInvitationsForOrganizationQueryKey)(id);
    const queryFn = () => (0, exports.organizationControllerGetInvitationsForOrganization)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useOrganizationControllerGetInvitationsForOrganization = useOrganizationControllerGetInvitationsForOrganization;
const organizationControllerGetUsers = (id) => {
    return (0, response_type_8.default)({ url: `/api/Organization/${id}/users`, method: 'get'
    });
};
exports.organizationControllerGetUsers = organizationControllerGetUsers;
const getOrganizationControllerGetUsersQueryKey = (id) => [`/api/Organization/${id}/users`];
exports.getOrganizationControllerGetUsersQueryKey = getOrganizationControllerGetUsersQueryKey;
const useOrganizationControllerGetUsers = (id, options) => {
    var _a;
    const { query: queryOptions } = options || {};
    const queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : (0, exports.getOrganizationControllerGetUsersQueryKey)(id);
    const queryFn = () => (0, exports.organizationControllerGetUsers)(id);
    const query = (0, react_query_1.useQuery)(queryKey, queryFn, Object.assign({ enabled: !!(id) }, queryOptions));
    return Object.assign({ queryKey }, query);
};
exports.useOrganizationControllerGetUsers = useOrganizationControllerGetUsers;
const organizationControllerRemoveMember = (id, memberId) => {
    return (0, response_type_9.default)({ url: `/api/Organization/${id}/remove-member/${memberId}`, method: 'put'
    });
};
exports.organizationControllerRemoveMember = organizationControllerRemoveMember;
const useOrganizationControllerRemoveMember = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, memberId } = props || {};
        return (0, exports.organizationControllerRemoveMember)(id, memberId);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerRemoveMember = useOrganizationControllerRemoveMember;
const organizationControllerChangeMemberRole = (id, userId, updateMemberDTO) => {
    return (0, response_type_10.default)({ url: `/api/Organization/${id}/change-role/${userId}`, method: 'put',
        data: updateMemberDTO
    });
};
exports.organizationControllerChangeMemberRole = organizationControllerChangeMemberRole;
const useOrganizationControllerChangeMemberRole = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, userId, data } = props || {};
        return (0, exports.organizationControllerChangeMemberRole)(id, userId, data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerChangeMemberRole = useOrganizationControllerChangeMemberRole;
const organizationControllerSetSelfOwnershipFlag = (id, setOwnershipDTO) => {
    return (0, response_type_11.default)({ url: `/api/Organization/${id}/self-ownership`, method: 'put',
        data: setOwnershipDTO
    });
};
exports.organizationControllerSetSelfOwnershipFlag = organizationControllerSetSelfOwnershipFlag;
const useOrganizationControllerSetSelfOwnershipFlag = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { id, data } = props || {};
        return (0, exports.organizationControllerSetSelfOwnershipFlag)(id, data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerSetSelfOwnershipFlag = useOrganizationControllerSetSelfOwnershipFlag;
const organizationControllerSetBlockchainAddress = (bindBlockchainAccountDTO) => {
    return (0, response_type_12.default)({ url: `/api/Organization/chain-address`, method: 'post',
        data: bindBlockchainAccountDTO
    });
};
exports.organizationControllerSetBlockchainAddress = organizationControllerSetBlockchainAddress;
const useOrganizationControllerSetBlockchainAddress = (options) => {
    const { mutation: mutationOptions } = options || {};
    const mutationFn = (props) => {
        const { data } = props || {};
        return (0, exports.organizationControllerSetBlockchainAddress)(data);
    };
    return (0, react_query_1.useMutation)(mutationFn, mutationOptions);
};
exports.useOrganizationControllerSetBlockchainAddress = useOrganizationControllerSetBlockchainAddress;
//# sourceMappingURL=organization.js.map